import React from "react";

import PageHeading from "2g-page-heading";

import { RezervaceTabs } from "b2b/components/rezervace-tabs/RezervaceTabs";
import getNejblizsiRezervaceProps from "b2b/components/rezervace-table/utils/getNejblizsiRezervaceProps";

export function RezervaceTabsExample() {
  return (
    <>
      <PageHeading>RezervaceTabs</PageHeading>
      <div data-testid="RezervaceTabs">
        <RezervaceTabs {...getNejblizsiRezervaceProps()} />
      </div>
    </>
  );
}

RezervaceTabsExample.propTypes = {};

export default React.memo(RezervaceTabsExample);
